import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Flex, Box } from 'reflexbox';

import actions from 'frontend/state/actions';
import { selectors } from 'frontend/state/reducers/simbot/reportOptions';

import SvgIcons from 'frontend/SvgIcons';
import config from 'frontend/config';

import ToggleView from 'frontend/components/ToggleView';

import BrowserNotificationToggle from './BrowserNotificationToggle';
import ReportName from './ReportName';
import TabOptions from './TabOptions';

const ReportOptions = ({ type, open, onToggleClick }) => (
  <ToggleView
    label={(
      <Flex align="center">
        <Box mr={1}>
          <SvgIcons.reportOptions.small
            style={{
              fill: config.colors.iconInfo,
              width: 26,
              height: 26,
            }}
          />
        </Box>
        <Box>Report and Notification Options</Box>
      </Flex>
)}
    open={open}
    onClick={onToggleClick}
  >
    <Box ml={2} pl={2} style={{ borderLeft: `1px solid ${config.colors.midgray}` }}>
      <ReportName type={type} />
      <BrowserNotificationToggle />
      <TabOptions />
    </Box>
  </ToggleView>
);

ReportOptions.propTypes = {
  type: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onToggleClick: PropTypes.func.isRequired,
};


const mapStateToProps = (state) => ({
  open: selectors.open(state),
});

const mapDispatchToProps = {
  onToggleClick: actions.toggleReportOptions,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportOptions);
